import { render, staticRenderFns } from "./LeadAcquiredByPeriod.vue?vue&type=template&id=937c0cc6&"
import script from "./LeadAcquiredByPeriod.vue?vue&type=script&lang=js&"
export * from "./LeadAcquiredByPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports